import React, { useRef, useState } from "react";
import ContactForm from "./ContactForm";
import Tabs from "./Sidetab";
import SupportBox from "./SupportBox";
import CTA from "./CTASection";
import Elevate from "./ElevateContent";
import Partners from "./ComplianceContent";
import Accelerate from "./AcceleratorContent";
import HeroPartners from "./PartnersHero";
import HeroElevate from "./ElevateHero";
import HeroAccelerate from "./AcceleratorHero";
import "../styles/RegulatoryCompliance.css";

const AcceleratorSection = () => {
  const [activeTab, setActiveTab] = useState("Nexa Accelerate");
  const formRef = useRef(null); // ✅ Ref for ContactForm

  const handleBookClick = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      formRef.current.querySelector("input")?.focus();

      // Optional: highlight effect
      formRef.current.classList.add("highlight");
      setTimeout(() => {
        formRef.current.classList.remove("highlight");
      }, 2000);
    }
  };

  const renderHero = () => {
    switch (activeTab) {
      case "Nexa Partners":
        return <HeroPartners />;
      case "Nexa Elevate":
        return <HeroElevate />;
      case "Nexa Accelerate":
      default:
        return <HeroAccelerate />;
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Nexa Partners":
        return <Partners />;
      case "Nexa Elevate":
        return <Elevate />;
      case "Nexa Accelerate":
      default:
        return <Accelerate />;
    }
  };

  return (
    <div className="compliance-wrapper">
      {renderHero()}
      <div className="compliance-container">
        <div className="sidebar-form">
          <Tabs onSelectTab={setActiveTab} activeTab={activeTab} />
          <ContactForm ref={formRef} />
          <SupportBox />
          <CTA onClick={handleBookClick} />
        </div>
        {renderContent()}
      </div>
    </div>
  );
};

export default AcceleratorSection;
